// NOTE: `statsGoals` (stats goals) ≠ the existing `goals` namespace
// (public goal tags in goals.queryKeys.ts).
import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchGoalsArgs } from '../api/types/statsInsights.types';

import { fetchGoals } from '../api/goalsStats.api';

export const statsGoalsQueryKeys = createQueryKeys('statsGoals', {
  fetchGoals: (args: FetchGoalsArgs = {}) => ({
    queryFn: () => fetchGoals(args),
    queryKey: [args],
  }),
});
